import * as React from "react";
import { Button } from "./button";

interface AppTitleProps {
    onInfoButtonClicked: () => void;
}

export class AppTitle extends React.Component<AppTitleProps, {}> {
    render(): JSX.Element {
        return <div>
            <div className="hbox vcenter-aligned app-name-text"><div>SOCIAL MEDIA WORLDMAP&nbsp;</div><Button onClicked={this.props.onInfoButtonClicked} className="info-open-button" normalImgSrc="assets/app/images/button-info.png"/></div>
            <div className="atos-logo-text">by <div className="atos-logo"/></div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/appTitle.tsx